import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Discount } from '../../types/discount.interface';
import { ModalService } from '../../core/services/modal.service';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-discount-block-widget',
	templateUrl: './discount-block-widget.component.html',
	styleUrls: ['./discount-block-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DiscountBlockWidgetComponent {
	@Input() discount: Discount;

	public confirmText;

	constructor(
		private modalService: ModalService,
		private as: AnalyticsService,
	) { }

	openUrl(discount) {
		const options = {
			section: 7,
			section_headline: 'Featured Discount',
			tile_placement: 1,
			tile_headline: discount.partnerName,
			cta: discount.redemptionCTA,
		};

		this.as.homepageTracking(options);

		window.open(`${discount.redemptionUrl}`, '_blank');
	}

	showDiscount(discount) {
		const options = {
			section: 7,
			section_headline: 'Featured Discount',
			tile_placement: 2,
			tile_headline: discount.partnerName,
			cta: discount.redemptionCTA,
		};

		this.as.homepageTracking(options);

		this.discount = discount;
		this.confirmText = `Enter the code above at checkout to redeem this discount from ${this.discount.partnerName}`;
		this.modalService.open('modal-promo');
	}
}
